import axios from "../../../config/axiosConfig";

export const getDevolucionAsignados = (cod) =>
  axios.get(`/api/req-devolucion/${cod}/asignados`);

export const getModemsByPlaca = (placa, serv) => {
  if (!placa) {
    throw new Error("placa es requerida");
  }

  if (!serv) {
    throw new Error("serv es requerido");
  }

  return axios.get(
    `/api/req-devolucion/placa/${encodeURIComponent(placa)}/modems`,
    {
      params: { serv }
    }
  );
};

export const postDevolverReq = (cod, payload, config = {}) =>
  axios.post(`/api/req-devolucion/${cod}/devolver`, payload, config);

export const getTransferenciaPreview = (cod) =>
  axios.get(`/api/req-devolucion/${cod}/transferencia-preview`);

export const postConfirmarTransferencia = (cod, body) =>
  axios.post(`/api/req-devolucion/${cod}/confirmar-transferencia`, body);
